// extracted by mini-css-extract-plugin
module.exports = {"row":"clickableStyles_row__4cRpL","col":"clickableStyles_col__ZlsTv","slide-in-out":"clickableStyles_slide-in-out__zy57r","fade-in-out":"clickableStyles_fade-in-out__LMWje"};